import { createFileRoute } from "@tanstack/react-router";
import { HomePage } from "../ui/components/pages/HomePage.tsx";
import SzBackdrop from "../ui/components/UISharedConstructors/Loading/SzBackDrop.tsx";

export const Route = createFileRoute("/")({
	component: HomePage,
	pendingComponent: () => <SzBackdrop message="načítám domovskou stránku" />,
});
